import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=06ead547&scoped=true&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookDetail.vue?vue&type=style&index=0&id=06ead547&lang=scss&scoped=true&"
import style1 from "./BookDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ead547",
  null
  
)

export default component.exports